import { createAction } from '@reduxjs/toolkit'

export setLoading = createAction('acl/loadingSet')

export setUsers = createAction('acl/usersSet')
export addUser = createAction('acl/userAdded')
export updateUser = createAction('acl/userUpdated')
export deleteUser = createAction('acl/userDeleted')

export setRoles = createAction('acl/rolesSet')
export addRole = createAction('acl/roleAdded')
export updateRole = createAction('acl/roleUpdated')
export deleteRole = createAction('acl/roleDeleted')

export setSpaces = createAction('acl/spacesSet')
export addSpace = createAction('acl/spaceAdded')
export updateSpace = createAction('acl/spaceUpdated')
export deleteSpace = createAction('acl/spaceDeleted')

export setAclFunctions = createAction('acl/aclFunctionsSet')
export addAclFunction = createAction('acl/aclFunctionsAdded')
export updateAclFunction = createAction('acl/aclFunctionsUpdated')
export deleteAclFunction = createAction('acl/aclFunctionsDeleted')

export setDomains = createAction('acl/domainsSet')
export addDomain = createAction('acl/domainAdded')
export updateDomain = createAction('acl/domainUpdated')
export deleteDomain = createAction('acl/domainDeleted')
